import React, { PropTypes } from 'react';

export default function BorrowingList({ children }) {
  return (
    <div className="cp-borrowing-list">
      {children}
    </div>
  );
}

BorrowingList.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingList/BorrowingList.jsx